import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-sand bg-cream px-5 py-14 text-center sm:px-8" data-id="element-94" data-mp="3geze367ujv27">
      <div className="mx-auto w-full max-w-2xl" data-id="element-95" data-mp="32o4bucrusc7l">
        <p className="text-lg font-extrabold uppercase tracking-[0.14em] text-navy sm:text-xl" data-id="element-96" data-mp="32pffmclatjyp">
          Innebandy Ready
        </p>

        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-muted" data-id="element-97" data-mp="36n3bbhutfgrn">
          En komplett, färdig innebandyläroplan för idrottslärare, tränare och familjer i
          hela Sverige.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm font-semibold text-navy" data-id="element-98" data-mp="3lec9ifcsaage">
          {footerLinks.map(link => <li key={link} data-id="element-99" data-mp="3qblvtm4vm600">
              <a href="#" className="transition-colors duration-150 ease-out hover:text-level-blue" data-id="element-100" data-mp="29z6tk9nn6feu">
                {link}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 text-xs text-muted" data-id="element-101" data-mp="3l8qv40rs6dpv">
          © 2026 Innebandy Ready — Alla rättigheter förbehållna.
        </p>
      </div>
    </footer>;
}